import dynamic from 'next/dynamic'

const Hero = dynamic(() => import('@/components/Hero2'))

export const HomeHeroSection = () => {
  return <Hero />
}
